Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    colors = _STYLES$useStyles.colors,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    boxShadows = _STYLES$useStyles.boxShadows,
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var container = Object.assign({}, box, {
    width: 'auto',
    alignItems: 'center',
    paddingHorizontal: bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal]) ? spacing.l : spacing.xxxl
  });
  var container_pointerOver = Object.assign({}, boxShadows.box_pointerOver.all);
  var label = Object.assign({}, fontSemiBold, {
    color: colors.brand,
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    textAlign: 'center',
    marginTop: spacing.xl
  });
  var value = Object.assign({}, fontBold, {
    color: COLORS.co2e,
    fontSize: bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal]) ? fontSize.xl : fontSize.xxl,
    lineHeight: bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m]) ? lineHeight.xl : lineHeight.xxl,
    paddingTop: _reactNative.Platform.OS === 'android' ? spacing.m : spacing.s
  });
  var unit = Object.assign({}, fontBold, {
    color: COLORS.co2e,
    fontSize: fontSize.m,
    lineHeight: lineHeight.m
  });
  var date = Object.assign({}, fontRegular, {
    color: COLORS.co2e,
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    marginBottom: spacing.l
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_pointerOver: container_pointerOver,
    value: value,
    unit: unit,
    date: date,
    label: label
  });
  return {
    styles: styles
  };
};